import React, {useState} from "react";
import "./pages.css"
import { Col, Row } from "react-bootstrap";
import { Link, useParams } from "react-router-dom";


// IMPORT PAGES
import AllPost from "../Inc/blog/blog-post-all";
import DesignAndTrends from "../Inc/blog/blog-designs-trends";
import Marketing from "../Inc/blog/blog-marketing";
import ProductsNew from "../Inc/blog/blog-products-new";
import SuccessStories from "../Inc/blog/blog-success-stories";
// IMPORT PAGES


import blogAll from "../../Resources/blog-all.png"
import designsTrends from "../../Resources/blog-designs-trends.png"
import marketing from "../../Resources/blog-marketing.png"
import productNew from "../../Resources/blog-product-new.png"
import sccuesStories from "../../Resources/blog-sccues-stories.png"

const Blog = () =>{

    // NAVIGATION LINKS INFORMATIONS
    const params = useParams().id
    console.log(params)
    // ACTIVATE NAV
    const [activateNav, setActivateNav] = useState(params)
    const handelClickNav = (val)=>setActivateNav(val)

    const navegation =  [
        {
            navName: "All Post",
            navLinks: "",
        },
        {
            navName: "Marketing Tips",
            navLinks: "/marketingTips",
        },
        {
            navName: "Design and Trends",
            navLinks: "/designAndTrends",
        },
        {
            navName: "Product News",
            navLinks: "/productNews",
        },
        {
            navName: "Success Stories",
            navLinks: "/successStories",
        }
    ]

    return(
       
        <Row>
            <Col sm={12}>
                <div className="blog-body-header-info">
                    <div className="blog-body-header-info-container">
                        <h1>
                            The Hive Blog
                        </h1>
                        <p>
                            Knowledge and inspiration for your Print on Demand business.
                        </p>
                    </div>
                </div>
                
                {
                    !activateNav &&
                    <div className="blog-body-header-img">
                        <img src={blogAll} alt="all blog photo" />
                    </div>
                }
                {
                    activateNav===navegation[1]["navLinks"] &&
                    <div className="blog-body-header-img">
                        <img src={marketing} alt="all blog photo" />
                    </div>
                }
                {
                    activateNav===navegation[2]["navLinks"] &&
                    <div className="blog-body-header-img">
                        <img src={designsTrends} alt="all blog photo" />
                    </div>
                }
                {
                    activateNav===navegation[3]["navLinks"] &&
                    <div className="blog-body-header-img">
                        <img src={productNew} alt="all blog photo" />
                    </div>
                }
                {
                    activateNav===navegation[4]["navLinks"] &&
                    <div className="blog-body-header-img">
                        <img src={sccuesStories} alt="all blog photo" />
                    </div>
                }
            
            </Col>
            <Col sm={12}>
                <div className="blog-body">
                    <div className="blog-body-nav">
                        <div className="blog-body-nav-main">
                           
                            <ul>
                                {
                                    navegation.map((val, idx)=>(
                                        <li 
                                            onClick={()=>handelClickNav(val["navLinks"])}
                                            key={idx}>
                                            {activateNav?
                                            <Link 
                                                className={activateNav===val["navLinks"]?"activated":""}
                                                to={`/Blog${val["navLinks"]}`}>

                                                {val["navName"]}

                                            </Link>:
                                            <Link 
                                                className={val["navLinks"]===""?"activated":""}
                                                to={`/Blog${val["navLinks"]}`}>

                                                {val["navName"]}

                                            </Link>
                                            }
                                        </li>
                                    ))
                                }
                            </ul>
                        </div>
                        <div className="blog-body-nav-search">
                            
                        </div>
                    </div>
                    <div className="blog-body-section">
                        {
                            !activateNav &&
                            <AllPost />
                        }
                        {
                            activateNav===navegation[1]["navLinks"] &&
                            <Marketing />
                        }
                        {
                            activateNav===navegation[2]["navLinks"] &&
                            <DesignAndTrends />
                        }
                        {
                            activateNav===navegation[3]["navLinks"] &&
                            <ProductsNew />
                        }
                        {
                            activateNav===navegation[4]["navLinks"] &&
                            <SuccessStories />
                        }
                    </div>
                </div>
            </Col>
        </Row>
        
    );
}

export default Blog